import { render, staticRenderFns } from "./SchoolAccountLink.vue?vue&type=template&id=1e6f490b&scoped=true&"
import script from "./SchoolAccountLink.vue?vue&type=script&lang=js&"
export * from "./SchoolAccountLink.vue?vue&type=script&lang=js&"
import style0 from "./SchoolAccountLink.vue?vue&type=style&index=0&id=1e6f490b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6f490b",
  null
  
)

export default component.exports